export class TableForm {

    table = undefined;
    config = {};
    data = [];
    target = undefined;
    constructor(table, config, data, target) {
        this.table = table;
        this.config = config;
        this.data = data;
        this.target = target;

        //check config
        if (typeof (config) !== 'object' || config === null)
            config = {};


        //init columns def
        if (!Array.isArray(config.columns))
            config.columns = [];


        //identify table row
        let columnCount = 0;
        $(table).find('thead>tr>th').each((idx, e) => {
            columnCount++;
            let colDef = undefined;

            //find column def in config
            for (let i = 0; i < config.columns.length; i++) {
                if (typeof (config.columns[i]) !== 'object' ||
                    config.columns[i] === null
                )
                    continue;

                if (config.columns[i].index == idx) {
                    colDef = config.columns[i];

                    break;
                }
            }
            let isNew = false;

            if (typeof (colDef) === 'undefined') {
                colDef = { index: idx };
                isNew = true;
            }

            colDef.col = $(e).data('col');
            colDef.autocol = $(e).data('autocol');

            if(typeof($(e).data('render')) !== 'undefined' )
                colDef.render = $(e).data('render');

            if (isNew)
                config.columns.push(colDef);
        });

        if (typeof (config.columnCount) === 'undefined')
            config.columnCount = columnCount;


        //Add New Button
        $(this.table).find('.js-table-form-button[data-function="add_new"').on('click', () => { this.insertRow() });


        this.refreshForm();

    };
    refreshForm() {
        //rebuild form elements
        let tbody = $(this.table).find('tbody');

        //clear tbody
        tbody.html('');


        //Construct tr
        let rowIndex = 0;
        this.data.forEach(rowData => {
            let tr = $('<tr>');

            //construct columns
            for (let colIdx = 0; colIdx < this.config.columnCount; colIdx++) {
                let td = $('<td>');
                //find coldef
                let colDef = this.config.columns.find(def => (typeof (def) !== 'undefined' && def !== null && def.index == colIdx));

                if (typeof (colDef) === 'object' && colDef !== null) {
                    if(typeof(colDef.class) === 'string')
                    {
                        td.addClass(colDef.class);
                    }
                    if (typeof (colDef.autocol) === 'string') {
                        if (colDef.autocol == 'autonumber')
                        {
                            if(typeof(colDef.render) === 'function')
                                colDef.render(td[0],rowIndex + 1,rowData,colDef,this); //render(<element>,<text data>,<row data>,<col def>,<tableform>)
                            else
                                td.html(rowIndex + 1);
                        }
                        else if (colDef.autocol == 'button_delete')
                        {
                            if(typeof(colDef.render) === 'function')
                                colDef.render(td[0],this.constructButtonDelete(rowData),rowData,colDef,this);
                            else
                                td.append(this.constructButtonDelete(rowData));
                        }

                    }

                    if (typeof (colDef.col) === 'string')
                    {

                        if(typeof(colDef.render) === 'function')
                            colDef.render(td[0],this.getPropValueFromObject(rowData,colDef.col),rowData,colDef,this);

                        else
                            td.append(this.constructField(rowData, colDef.col));


                    }


                }

                tr.append(td);
            }
            tbody.append(tr);
            rowIndex++;
        });

        this.config.columns.forEach(col => {

        });
    };
    getPropValueFromObject(data,prop)
    {
        let propParts = prop.split('.');
        let obj = data;
        propParts.forEach(function(part){
            if(typeof(obj) !== 'object' || obj === null || typeof(obj[part]) === 'undefined')
                return undefined;

            obj = obj[part];
        });

        return obj;
    };
    constructField(data, col) {
        let input = $('<input type="text" class="form-control">')
            .val(this.getPropValueFromObject(data,col))
            .data('col', col)
            .data('rowData', data)
            .data('rowsData', this.data)
            .data('tableform', this)
            .on('focusout', this._updateField)
        return input;
    };
    constructButtonDelete(data) {
        console.log(data);
        return $($('#template-table-form-button-delete').html())
            .data('rowData', data)
            .data('rowsData', this.data)
            .data('tableform', this)
            .on('click', this._clickDeleteRow);
    };
    _updateField() {
        $(this).data('rowData')[$(this).data('col')] = $(this).val();

    };
    _clickDeleteRow() {
        $(this).data('rowsData').splice($(this).data('rowsData').indexOf($(this).data('rowData')), 1);
        $(this).data('tableform').refreshForm();
    };

    insertRow() {
        let rowData = {};
        this.config.columns.forEach(colDef => {
            if(typeof(colDef.col) !== 'undefined')
                rowData[colDef.col] = '';


        });
        this.data.push(rowData);
        this.refreshForm();
        // this.data()
    };
    updateTargetField()
    {
        $(this.target).val(JSON.stringify(this.data));
    }


}
